import { Stack, Typography } from "@mui/material";

import { CarrierStatsRow } from "components/CarrierStatsRow";
import { CompanyBusinessTypeChip } from "components/CompanyBusinessTypeChip";
import { NewTabLink } from "components/NewTabLink";
import { useCarrierStats } from "hooks";
import { getCompanyProfilePath } from "utils";

interface Props {
  companyId: number;
  companyBusinessType?: BusinessTypeValue | null;
}

export function CarrierCompanyNameAndReputationLabel(props: Props) {
  const { companyId, companyBusinessType = null } = props;
  const { carrierMeta } = useCarrierStats({ companyId });

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <NewTabLink href={getCompanyProfilePath(companyId)}>
        <Typography>View Carrier Profile</Typography>
      </NewTabLink>
      {carrierMeta && <CarrierStatsRow carrierMeta={carrierMeta} />}
      {companyBusinessType && (
        <CompanyBusinessTypeChip businessType={companyBusinessType} />
      )}
    </Stack>
  );
}
